var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeutralDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "illustration styles_illustrationTablet__1DWOa",
    width: 406,
    height: 306,
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "#283_neutral_face_flatline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m260.47 213.22h-0.21a4 4 0 0 1 -3.79 -4.2l5.61-105.15a4 4 0 0 1 8 0.43l-5.61 105.14a4 4 0 0 1 -4 3.78z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.51,186.68l1.13,21.58s-3,18.4,0,16.52S253,213.52,253,213.52s-2.26,14.38,3.75,16.85,13.21,1.35,13.89-6.15-.3-31.35-.3-31.35Z",
    fill: "#1a202c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.35,232.08a15.47,15.47,0,0,1-5.84-1.23c-3.55-1.47-4.42-6.61-4.49-10.93-.72,2.25-1.75,4.45-3.11,5.3a1.07,1.07,0,0,1-1.21.05c-2-1.31-.19-13.3.42-17L247,186.7a.52.52,0,0,1,.19-.43.54.54,0,0,1,.46-.09l22.78,6.19a.51.51,0,0,1,.38.48c0,.24,1,24,.3,31.41a8.08,8.08,0,0,1-3.72,6.53A9.64,9.64,0,0,1,262.35,232.08Zm-8.9-18.34c-.21,1.47-1.8,14,3.46,16.16,3.66,1.51,7.47,1.51,9.95,0a7,7,0,0,0,3.22-5.74c.63-6.87-.16-27.82-.28-30.9l-21.73-5.91,1.09,20.87s0,.08,0,.11c-1.33,8.13-1.73,15.46-.89,16.06l.11-.06c2.21-1.38,3.62-7.86,4-10.61,0-.15,0-.25,0-.29A.5.5,0,0,1,253,213a.52.52,0,0,1,.44.58A.88.88,0,0,0,253.45,213.74Z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "translate(507.36 395.46) rotate(183.88)",
    x: 243.04,
    y: 184.88,
    width: 34.67,
    height: 8.51,
    rx: 3.99,
    fill: "#1a202c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.69,194.81h-.31L246.74,193a4.5,4.5,0,0,1-4.19-4.8l0-.53a4.49,4.49,0,0,1,4.79-4.19L274,185.28a4.51,4.51,0,0,1,4.19,4.79l0,.54a4.5,4.5,0,0,1-4.48,4.2Zm-26.62-10.32a3.47,3.47,0,0,0-3.45,3.24l0,.53a3.46,3.46,0,0,0,.85,2.52,3.42,3.42,0,0,0,2.38,1.18l26.64,1.81a3.47,3.47,0,0,0,3.69-3.23l0-.54a3.47,3.47,0,0,0-3.23-3.69l-26.64-1.81h-.24Z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.05,213.22a4,4,0,0,1-4-3.79l-5.61-105.14a4,4,0,0,1,8-.43L156.05,209a4,4,0,0,1-3.78,4.2Z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,186.68l-1.13,21.58s3,18.4,0,16.52-4.31-11.26-4.31-11.26,2.25,14.38-3.76,16.85-13.21,1.35-13.89-6.15.31-31.35.31-31.35Z",
    fill: "#1a202c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.17,232.08a9.64,9.64,0,0,1-5-1.29,8.08,8.08,0,0,1-3.72-6.53c-.68-7.45.29-31.17.3-31.41a.51.51,0,0,1,.38-.48l22.78-6.19a.54.54,0,0,1,.46.09.52.52,0,0,1,.19.43l-1.12,21.53c.61,3.74,2.39,15.73.42,17a1.07,1.07,0,0,1-1.21-.05c-1.36-.85-2.38-3.05-3.11-5.3-.07,4.32-.94,9.46-4.49,10.93A15.47,15.47,0,0,1,150.17,232.08Zm-7.44-38.81c-.13,3.08-.92,24-.29,30.9a7,7,0,0,0,3.22,5.74c2.48,1.5,6.29,1.5,10,0,5.27-2.17,3.67-14.69,3.47-16.16,0-.08,0-.13,0-.15a.52.52,0,0,1,.44-.58.52.52,0,0,1,.59.43s0,.14,0,.29c.42,2.75,1.82,9.23,4,10.61l.12.06c.82-.55.42-7.9-.91-16.06a.4.4,0,0,1,0-.11l1.09-20.87Z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "translate(-12.46 10.73) rotate(-3.88)",
    x: 134.81,
    y: 184.88,
    width: 34.67,
    height: 8.51,
    rx: 3.99,
    fill: "#1a202c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.83,194.81a4.5,4.5,0,0,1-4.48-4.2l0-.54a4.5,4.5,0,0,1,4.19-4.79l26.64-1.81a4.45,4.45,0,0,1,3.26,1.1,4.51,4.51,0,0,1,1.54,3.09l0,.53a4.5,4.5,0,0,1-4.18,4.8l-26.65,1.81Zm26.38-10.31-26.64,1.81a3.47,3.47,0,0,0-3.23,3.69l0,.54a3.47,3.47,0,0,0,3.69,3.23L165.72,192a3.42,3.42,0,0,0,2.37-1.18,3.46,3.46,0,0,0,.85-2.52l0-.53a3.5,3.5,0,0,0-1.18-2.38,3.42,3.42,0,0,0-2.52-.85Zm0-.51h0Z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.63 240a4 4 0 0 1 -4 -4v-87a4 4 0 0 1 8 0v87a4 4 0 0 1 -4 4z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.89 240a4 4 0 0 1 -4 -4v-87a4 4 0 0 1 8 0v87a4 4 0 0 1 -4 4z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.26,
    cy: 257.33,
    rx: 64.03,
    ry: 7.61,
    fill: "#2d3748"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.26,
    cy: 116.29,
    r: 65.45,
    fill: "#e53838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.3 50.84a65.45 65.45 0 0 1 2 130.86h-2.11a65.45 65.45 0 0 1 -2 -130.86h2.11m0-1h-2.15a66.48 66.48 0 0 0 2.07 132.93h2.15a66.48 66.48 0 0 0 -2.07 -132.97z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.08 5.91) rotate(-1.82)",
    cx: 184.73,
    cy: 100.25,
    rx: 5.2,
    ry: 12.34,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -.03 .03 1 -3.02 7.27)",
    cx: 227.79,
    cy: 98.89,
    rx: 5.2,
    ry: 12.34,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.55 5.16) rotate(-1.82)",
    cx: 160.87,
    cy: 114.48,
    rx: 7.96,
    ry: 5.06,
    fill: "#1a202c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.5 8.03) rotate(-1.82)",
    cx: 251.65,
    cy: 114.48,
    rx: 7.96,
    ry: 5.06,
    fill: "#1a202c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.71,218.21s-28.22-5.51-28.45-2.76.92,25.27.92,25.27-27,14.51-22.84,16.35,50.37-6.7,50.37-6.7Z",
    fill: "#1a202c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.68,257.83a7.38,7.38,0,0,1-2.55-.29,1.13,1.13,0,0,1-.74-1c0-.64-.08-2.31,11.84-9.57,5.05-3.07,10.17-5.87,11.42-6.55-.15-2.88-1.12-22.4-.9-25a1,1,0,0,1,.4-.7c2.61-2,24.33,2.15,28.66,3a.52.52,0,0,1,.42.51v32.16a.52.52,0,0,1-.42.51C200.57,251.66,166.84,257.83,156.68,257.83Zm22.42-42.66c-1.3,0-2.12.12-2.34.38-.21,2.64.92,24.92.94,25.15a.54.54,0,0,1-.27.48c-11.36,6.11-23.07,13.51-23,15.32,0,0,.05.06.13.1,3.24,1.44,36.52-4.25,49.65-6.66v-31.3C194.22,216.7,183.7,215.17,179.1,215.17Z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.81,218.21s28.22-5.51,28.45-2.76-.92,25.27-.92,25.27,27,14.51,22.84,16.35-50.37-6.7-50.37-6.7Z",
    fill: "#1a202c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.84,257.83c-10.15,0-43.89-6.17-48.13-6.95a.52.52,0,0,1-.42-.51V218.21a.52.52,0,0,1,.42-.51c4.33-.84,26-5,28.66-3a1,1,0,0,1,.4.7c.22,2.61-.75,22.13-.9,25,4.54,2.45,23.38,12.83,23.26,16.12a1.13,1.13,0,0,1-.74,1A7.38,7.38,0,0,1,255.84,257.83Zm-47.52-7.89c13.13,2.41,46.42,8.1,49.65,6.66.08,0,.13-.07.13-.1.07-1.81-11.64-9.21-23-15.32a.52.52,0,0,1-.27-.48c0-.23,1.14-22.51.92-25.2-1-1.16-14.65.66-27.43,3.14Z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.18,140.31H165.34a1.5,1.5,0,1,1,0-3h81.84a1.5,1.5,0,0,1,0,3Z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.08,
    cy: 150,
    r: 8.46,
    fill: "#2d3748"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.23,
    cy: 150,
    r: 8.46,
    fill: "#2d3748"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.77,
    cy: 150,
    r: 8.46,
    fill: "#2d3748"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.92,
    cy: 150,
    r: 8.46,
    fill: "#2d3748"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralDark);
export default __webpack_public_path__ + "static/media/neutral-dark.098737caad6fededb317ea4c77a30f02.svg";
export { ForwardRef as ReactComponent };